import React, { useState } from "react"
import PropTypes from "prop-types"

import DateTime from "../../Inputs/DateTime"

import styles from "./styles.css"

import { phone } from "services/utils/mask"
import { TEXT_ACTION } from "../constants"

import iconArrowUp from "../../../../../assets/svg/fixed_voice_arrow_select_up.svg"
import iconArrowDown from "../../../../../assets/svg/fixed_voice_select_arrow.svg"

const PortabilityEdit = ({
  formikPortability,
  action,
  customerSelected,
  datesMapped
}) => {
  const { touched, errors, handleChange } = formikPortability
  const [show, setShow] = useState(false)
  const isErrorField = touched.protocolNumbers && errors.protocolNumbers
  const isReschedule = action === "Reagendar portabilidade"

  const showProtocols = () => {
    setShow(!show)
  }

  return (
    <div className={styles.portabilityFormClass}>
      <div
        className={`${styles.selected_checkbox} ${
          show && styles.selected_option
        }`}
        onClick={() => showProtocols()}
      >
        <div>{`Quais protocolos deseja ${TEXT_ACTION[action].label}?`}</div>
        {show ? (
          <img className={styles.arrow_up} src={iconArrowUp} alt={"Arrow Up"} />
        ) : (
          <img src={iconArrowDown} alt={"Arrow Down"} />
        )}
      </div>

      {show && (
        <div className={styles.box_protocols}>
          <div>
            <div className={styles.box_protocols_display}>
              <div className={styles.display_align}>
                <input
                  name="protocolNumbers"
                  type="checkbox"
                  className={styles.custom_checkbox}
                  onChange={handleChange}
                  value={customerSelected.protocol}
                  checked={formikPortability.protocol}
                />
                {customerSelected.protocol}
              </div>
              <div className={styles.protocol_number}>
                {phone(customerSelected.phone)}
              </div>
            </div>
          </div>
        </div>
      )}

      {isErrorField && <div className={styles.error}>{errors.protocol}</div>}

      {isReschedule && (
        <DateTime dates={datesMapped} formik={formikPortability} />
      )}
    </div>
  )
}

PortabilityEdit.propTypes = {
  formikPortability: PropTypes.object,
  action: PropTypes.string,
  customerSelected: PropTypes.object,
  datesMapped: PropTypes.object
}

export default PortabilityEdit



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/ActionForm/PortabilityEdit/index.js